
import InputWrapper from '@/components/common/InputWrapper.vue'
import InputPassword from '@/components/common/InputPassword.vue'
import { useApi } from '@/lib/api'
import { useStore } from 'vuex'
import { GlobalState } from '@/lib/types'
import { useRouter } from 'vue-router'
import { errorMap } from '@/lib/filters'
import { defineComponent, ref, getCurrentInstance } from 'vue'
import NewsTop from '@/components/NewsTop.vue'

export default defineComponent({
  components: { InputWrapper, NewsTop, InputPassword },
  setup() {
    const _api = useApi()
    const _inst = getCurrentInstance()
    const _store = useStore<GlobalState>()
    const _router = useRouter()
    const data = ref({})
    const certData = ref({})
    const userData = ref({})
    const lostPasswordEmail = ref()

    const login = async () => {
      lostPasswordEmail.value = null

      const res = await _api.post<any>('login', data.value)
      if (res.status === 200) {
        _store.commit('user', res.data)
        _router.push({ name: 'reportList' })
      }
    }

    const getCert = async () => {
      try {
        const res = await _api.axios.get<any>('cert')
        if (res.status === 200) {
          certData.value = res.data.cert
          userData.value = res.data.user
        }
      } catch (e) {
        if (e.response.status === 403) {
          _store.commit('appErrors', [{ key: '.', message: 'Izbrano je nekvalificirano potrdilo' }])
        }
      }
    }

    const lostPassword = async () => {
      lostPasswordEmail.value = null
      const res = await _api.post<any>('lostPassword', null)
      if (res.status === 200) {
        lostPasswordEmail.value = res.data
        _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Novo geslo poslano.' })
      }
    }

    getCert()

    return { certData, userData, data, errorMap, login, lostPassword, lostPasswordEmail }
  }
})
